import { Phone, MessageCircle } from "lucide-react";
import { TEL_URL, WA_URL } from "@/lib/site";

export const MobileBar = () => (
    <div
        data-testid="mobile-bottom-bar"
        className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 px-4 py-2.5 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur-xl md:hidden"
    >
        <div className="flex items-center gap-2.5">
            <a
                href={TEL_URL}
                data-testid="mobile-bar-call-btn"
                className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-[#17255A] py-3 text-sm font-bold text-white transition-transform duration-150 active:scale-95"
            >
                <Phone className="h-4 w-4" /> CALL NOW
            </a>
            <a
                href={WA_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="mobile-bar-whatsapp-btn"
                className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-[#2563EB] py-3 text-sm font-bold text-white transition-transform duration-150 active:scale-95"
            >
                <MessageCircle className="h-4 w-4" /> WHATSAPP
            </a>
        </div>
    </div>
);
